import { render, staticRenderFns } from "./RPDropdown.vue?vue&type=template&id=6bf0da39&"
import script from "./RPDropdown.vue?vue&type=script&lang=js&"
export * from "./RPDropdown.vue?vue&type=script&lang=js&"
import style0 from "./RPDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RPDropdown.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports